export default __webpack_public_path__ + "static/media/Site_Leader_Role.e5102bba.svg";